import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Popup, Grids, PopupHeader} from 'react-weui';
import axios from 'axios';
import RecordingTips from '../RecordingTips';
import FileSelector from '../FileSelector';
import {AudioRecorder, WebAudioRecorder} from '..';
import {getTimestamp, isNewWeiXinMachine} from '../../utils'
import tipsImg from '../../images/ended-class-tips.png';
import { WKCommentDialog } from '../../components/wk'


import '../../styles/classroom/ClassroomControlBar.css';


class ClassroomControlBar extends Component {
    constructor() {
        super();
        this.onShowDiscussPanel = this.onShowDiscussPanel.bind(this);
        this.onRecordAudio = this.onRecordAudio.bind(this);
        this.onTextInputClick = this.onTextInputClick.bind(this);
        this.onTextSubmit = this.onTextSubmit.bind(this);
        this.handleChooseImage = this.handleChooseImage.bind(this);
        this.handleChooseAudio = this.handleChooseAudio.bind(this);
        this.onCancelRecord = this.onCancelRecord.bind(this);
        this.onWebCancelRecord = this.onWebCancelRecord.bind(this);
        this.onCloseReply = this.onCloseReply.bind(this);
        this.onTextInputFocus = this.onTextInputFocus.bind(this);
        this.onTextInputBlur = this.onTextInputBlur.bind(this);
        this.onTextInputKeyUp = this.onTextInputKeyUp.bind(this);
        this.onVoiceInputTouchStart = this.onVoiceInputTouchStart.bind(this);
        this.onVoiceInputTouchMove = this.onVoiceInputTouchMove.bind(this);
        this.onVoiceInputTouchEnd = this.onVoiceInputTouchEnd.bind(this);
        this.onVoiceInputClick = this.onVoiceInputClick.bind(this);
        this.onOpenUserMenu = this.onOpenUserMenu.bind(this);
    }

    state = {
        showPlusCommands: false,
        plusCommands: [],
        writing: false,
        inputMode: 'text',
        touchPosition: {},
        duration: 0,
        cancelling: false,
        clickMode: false,
        tipsDialogInit: false,
        isShowCommentDialog: false,
    };

    hide() {
        this.setState({
            showPlusCommands: false,
            writing: false
        });
    }

    onOpenMaterialPanel() {
        this.setState({showPlusCommands: false});
        this.props.dispatch({
            type: 'OPEN_MATERIAL_PANEL'
        })
    }

    onShowDiscussPanel() {
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_DISCUSS_PANEL',
            payload: 'discuss_list'
        })
    }

    onOpenPPTMaterialPanel() {
        this.setState({showPlusCommands: false});
        this.props.dispatch({
            type: 'OPEN_PPT_MATERIAL_PANEL'
        })
    }

    onOpenCardPanel() {
        this.setState({showPlusCommands: false});
        this.props.dispatch({
            type: 'OPEN_CARD_PANEL'
        })
    }


    onOpenCheckIn() {
        this.setState({showPlusCommands: false});
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_CHECK_IN'
        });
    }

    onOpenRedpackPanel() {
        this.setState({showPlusCommands: false});
        this.props.dispatch({
            type: 'OPEN_REDPACK_PANEL'
        })
    }

    onOpenTextareaPanel() {
        this.setState({showPlusCommands: false});
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_TEXTAREA_PANEL'
        })
    }

    onRecordAudio() {
        const {lecture} = this.props;
        const {tipsDialogInit} = this.state;

        if (/WindowsWechat/.test(navigator.userAgent)) {
            let text = `微信电脑版不支持录音，请使用谷歌浏览器，打开荔枝微课（${window.location.href}）开始授课`;
            let title = '温馨提示';
            this.context.page.showAlert(text, null, title);
            return;
        }

        if (lecture.status === 'closed') {
            if (!tipsDialogInit) {
                this.props.dispatch({
                    type: 'COMPONENT_INIT_IMGTIPS_DIALOG',
                    payload: {
                        title: '温馨提示',
                        showTipsDialog: true,
                        img: tipsImg,
                        msg: '当前课程已结束，如需继续讲课，请创建新课程继续分享你的知识',
                        callback: () => {
                            this.setState({inputMode: 'press_to_record'})
                        }
                    }
                });
                this.setState({tipsDialogInit: true});
            } else {
                this.setState({inputMode: 'press_to_record'});
            }
        } else {
            this.setState({inputMode: 'press_to_record'});
        }
    }

    componentWillMount() {
        let {lecture, account} = this.props
        const commands = []
        const hasTopVideo = lecture.image_mode === 'video'
        commands.push({
            icon: <i className="iconfont icon-zhaopian"/>,
            label: '相册',
            onClick: this.onUploadImage.bind(this)
        })
        if (!hasTopVideo && this.props.options.ppt_open) {
            commands.push({
                icon: <i className="iconfont icon-zhaopian"/>,
                label: 'PPT',
                onClick: this.onOpenPPTMaterialPanel.bind(this)
            })
        }
        commands.push({
            icon: <i className="iconfont icon-sucai"/>,
            label: '素材库',
            onClick: this.onOpenMaterialPanel.bind(this)
        })
        commands.push({
            icon: <i className="iconfont icon-qiapian"/>,
            label: '卡片',
            onClick: this.onOpenCardPanel.bind(this)
        })
        commands.push({
            icon: <i className="iconfont icon-qiandao"/>,
            label: '签到',
            onClick: this.onOpenCheckIn.bind(this),
        })
        commands.push({
            icon: <i className="iconfont icon-hongbao"/>,
            label: '手气红包',
            onClick: this.onOpenRedpackPanel.bind(this)
        })


        if (window.platform === 'pc' || window.systemType === 'unknown') {
            commands.push({
                icon: <i className="iconfont icon-yuyin2-copy"/>,
                label: '录音文件',
                onClick: this.onOpenUploadAudio.bind(this)
            })
        }

        commands.push({
            icon: <i className="iconfont icon-wenjian"/>,
            label: '文件',
            onClick: this.onOpenFilePanel.bind(this)
        })

        this.setState({
            plusCommands: commands
        })
    }

    onOpenFilePanel() {
        this.setState({showPlusCommands: false})
        this.props.dispatch({type: 'CLASSROOM_SHOW_FILE_PANEL'})
    }

    onUploadImage() {
        this.setState({showPlusCommands: false});

        if (window.platform !== 'weixin') {
            this.refs.file_selector.trigger();
            return;
        }

        const {timestampDelta} = this.props;
        window.wx.chooseImage({
            count: 9, // 默认9
            sizeType: ['origin'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: (res) => {
                res.localIds.map((localId) => {
                    this.props.dispatch({
                        type: 'ML_SEND_MESSAGE',
                        payload: {
                            type: 'image',
                            account: this.props.account,
                            local_id: localId,
                            from: 'weixin',
                            timestamp: getTimestamp(timestampDelta),
                        }
                    });
                    return null;
                });
            }
        });
    }

    onOpenUploadAudio() {
        this.setState({showPlusCommands: false});
        this.refs.audio_selector.trigger();
    }

    handleChooseAudio(file, content) {
        let {account} = this.props;

        if (['audio/mpeg', 'audio/mp3'].indexOf(file.type) === -1) {
            return this.context.page.showTips('上传的录音文件不是MP3格式', 'warn');
        }

        const {timestampDelta} = this.props;
        let timestamp = getTimestamp(timestampDelta);
        this.props.dispatch({
            type: 'ML_SEND_MESSAGE',
            payload: {
                type: 'voice',
                account: account,
                audio: file,
                content: content,
                length: 0,
                from: 'pc',
                timestamp: timestamp,
            }
        });
        this.context.classroomPage.scrollToBottom(false)
    }


    handleChooseImage(image, content) {
        const {timestampDelta} = this.props;
        let timestamp = getTimestamp(timestampDelta);
        this.props.dispatch({
            type: 'ML_SEND_MESSAGE',
            payload: {
                type: 'image',
                account: this.props.account,
                image: image,
                content: content,
                from: 'pc',
                timestamp: timestamp,
            }
        })
    }

    componentDidMount() {
        this.ticks = window.setInterval(() => {
            if (this.props.audioRecorder.recorderState === 'recording') {
                const duration = Math.min(60, Math.ceil((Date.now() - this.props.audioRecorder.startRecordTime) / 950));
                this.setState({duration: duration});
                this.props.dispatch({
                    type: 'RECORDER_SET_DURATION',
                    payload: {recordDuration: duration}
                })

                if (window.platform === 'pc' && duration % 60 === 0) {
                    this.props.dispatch({type: 'RECORDER_FORCE_STOP', payload: {localId: ''}})
                }
                if(window.platform === 'weixin' && duration % 60 === 0){
                    this.props.dispatch({
                        type: 'RECORDER_STOP_RECORD',
                        payload: {
                            autoRecordNext: true
                        }
                    })
                }
            }
        }, 500);
    }

    componentWillUnmount() {
        window.clearInterval(this.ticks);
        this.fixInputPosition && clearInterval(this.fixInputPosition);
    }

    onOpenUserMenu() {
        this.props.dispatch({
            type: 'CLASSROOM_SET_MENU_DISPLAY',
            payload: true
        })
    }

    onTextSubmit(e) {
        if (e) e.preventDefault();
        this.setState({ isShowCommentDialog: false })
        const content = isNewWeiXinMachine() ? this.$textarea.value : this.refs.textInput.value;
        if (isNewWeiXinMachine()) {
            this.$textarea.value = ''
        }

        if (!this.state.writing) {
            this.hide();
        }

        let text = () => {
            return <p><i className="iconfont icon-cuowu wk-toast-error"/><span>不能发空白消息</span></p>
        };
        if (content.trim().length === 0) {
            this.context.page.showToast(text(), '', true, 2000)
            return;
        }

        if (content.length < 1) {
            return;
        }


        const {timestampDelta} = this.props;
        let timestamp = getTimestamp(timestampDelta);
        this.props.dispatch({
            type: 'ML_SEND_MESSAGE',
            payload: {
                type: 'text',
                content: content,
                account: this.props.account,
                reply: this.props.reply,
                timestamp: timestamp,
            }
        });
        this.props.dispatch({
            type: 'CLASSROOM_SET_REPLY',
            payload: null
        });
        this.refs.textInput.value = '';

        let controlSendText = document.getElementById('controlSendText');
        let controlBar = document.getElementById('controlBar');
        controlSendText.style.height = '32px';
        controlBar.style.height = '50px';
    }

    onVoiceInputTouchStart(e) {
        if (window.platform !== 'weixin')
            return
        if (this.props.audioRecorder.recorderState !== 'ready') {
            return;
        }

        const touch1 = e.touches[0];
        this.setState({touchPosition: touch1, cancelling: false, duration: 0});

        this.props.dispatch({
            type: 'RECORDER_START_RECORD'
        });
    }

    onVoiceInputClick(e) {
        if (window.platform === 'weixin') {
            if (this.props.audioRecorder.recorderState === 'start') {
                this.context.page.showTips('录满60秒语音将会自动发送并开始下一条')
                this.setState({clickMode: true})
            }
            return
        }
        switch (this.props.audioRecorder.recorderState) {
            case 'ready':
                this.setState({cancelling: false, duration: 0})
                this.props.dispatch({
                    type: 'RECORDER_START_RECORD'
                })
                break
            case 'recording':
                if (this.state.duration < 2) {
                    this.context.page.showTips('录音时间太短', 'warn')
                    return
                }
                this.props.dispatch({
                    type: 'RECORDER_STOP_RECORD'
                })
                this.context.classroomPage.scrollToBottom(false)
                break
            default:
                break
        }
    }

    onVoiceInputTouchMove(e) {
        if (window.platform !== 'weixin')
            return
        const touch2 = e.changedTouches[0];
        if (this.state.touchPosition.clientY - touch2.clientY > 100) {
            if (!this.state.cancelling) {
                this.setState({cancelling: true});
            }
        } else {
            if (this.state.cancelling) {
                this.setState({cancelling: false});
            }
        }
    }

    canShowRecordingTips() {
        const {audioRecorder} = this.props;
        return audioRecorder.recorderState === 'start' || audioRecorder.recorderState === 'recording';
    }

    onCancelRecord() {
        this.props.dispatch({
            type: 'RECORDER_CANCEL_RECORD'
        })
    }


    onWebCancelRecord() {
        this.props.dispatch({
            type: 'RECORDER_CANCEL_RECORD'
        })
    }

    onVoiceInputTouchEnd(e) {
        if (window.platform !== 'weixin')
            return
        if (!this.canShowRecordingTips()) {
            return;
        }
        if (this.state.cancelling) {
            this.props.dispatch({
                type: 'RECORDER_CANCEL_RECORD'
            });
            return;
        }

        if (this.state.duration < 2) {
            return;
        }
        this.setState({clickMode: false})
        this.props.dispatch({
            type: 'RECORDER_STOP_RECORD'
        });
    }

    componentDidUpdate() {
        const {audioRecorder, dispatch} = this.props;
        if (this.state.inputMode === 'press_to_record') {
            if (audioRecorder.recorderState === 'unchecked') {
                dispatch({
                    'type': 'RECORDER_CHECK'
                });
            } else if (audioRecorder.recorderState === 'recording') {
                if (this.state.duration % 5 === 0) {
                    this.sendRecordingNotify();
                }
            }
        }
    }

    sendRecordingNotify() {
        const {lecture, account} = this.props;
        const content = account.nickname + ' 正在输入';
        const m = {
            type: 'notify_recording',
            lecture_id: lecture.id,
            account: account,
            content: content
        };
        axios.post('/api/classroom/' + lecture.id + '/broadcast', m).then((response) => {
        })
    }

    getRecordButtonLabel() {
        const {audioRecorder} = this.props;
        if (window.platform !== 'weixin') {
            switch (audioRecorder.recorderState) {
                case 'recording':
                    return '单击发送'
                case 'check':
                    return '正在检查设备...'
                case 'not_available':
                    return '请使用谷歌浏览器'
                case 'start':
                    return '准备中...'
                default:
                    return '单击开始录音'
            }
        } else {
            switch (audioRecorder.recorderState) {
                case 'recording':
                    if (this.state.cancelling)
                        return '松开取消发送'
                    if (this.state.clickMode)
                        return '单击发送'
                    return '正在录音...'
                case 'check':
                    return '正在检查设备...'
                case 'not_available':
                    return '暂不支持该设备'
                case 'start':
                    return '准备中...'
                default:
                    return '点击 录音'
            }
        }
    }

    onTextInputFocus() {
        this.context.classroomPage.scrollToBottom(true);
        this.setState({writing: true});

        this.props.dispatch({
            type: 'CLASSROOM_VIRTUAL_FOCUS'
        })

        if (!isNewWeiXinMachine()) {
            this.fixInputPosition && clearInterval(this.fixInputPosition);
            this.fixInputPosition = setInterval(() => {
                document.body.scrollTop = document.body.scrollHeight;
            }, 1000);
        } else {
            this.setState({ isShowCommentDialog: true }, () => {
                this.$textarea.focus()
            })
        }
    }

    onTextInputClick() {
        this.refs.textInput.focus();
    }

    onTextInputBlur() {
        this.setState({writing: false});
        this.fixInputPosition && clearInterval(this.fixInputPosition);

        this.props.dispatch({
            type: 'CLASSROOM_VIRTUAL_BLUR'
        })

        if (this.refs.textInput.value === '') {
            let controlSendText = document.getElementById('controlSendText');
            let controlBar = document.getElementById('controlBar');
            controlSendText.style.height = '32px';
            controlBar.style.height = '50px'
            }
        }


    onTextInputKeyUp(e) {
        if (!isNewWeiXinMachine()) {
            e.target.style.height = e.target.scrollHeight + 'px';
               if (e.target.scrollHeight > 50) {
                document.getElementById('controlBar').style.height = (16+ e.target.scrollHeight) + 'px';
            }
        }
    }

    onCloseReply() {
        this.props.dispatch({
            type: 'CLASSROOM_SET_REPLY',
            payload: null
        })
    }

    render() {
        const {audioRecorder, reply} = this.props;
        const showInput = (this.refs.textInput && this.refs.textInput.value) || this.state.writing;
        const recording = audioRecorder.recorderState === 'recording';
        return (
            <form action="" method="post" onSubmit={this.onTextSubmit}>

                {window.platform === 'weixin' ? <AudioRecorder /> : <WebAudioRecorder />}

                <FileSelector ref="file_selector" handleChoose={this.handleChooseImage} multiple={true}
                              accept="image/*"/>
                <FileSelector ref="audio_selector" handleChoose={this.handleChooseAudio}
                              accept="audio/mpeg,audio/mp4,audio/aac"/>
                <Popup
                    show={this.state.showPlusCommands}
                    onRequestClose={e => this.setState({showPlusCommands: false})}
                >
                    <Grids data={this.state.plusCommands}/>
                </Popup>

                <RecordingTips show={this.canShowRecordingTips()} recording={recording} clickMode={this.state.clickMode}
                               duration={this.state.duration} cancelling={this.state.cancelling}
                               onCancelRecord={this.onCancelRecord}
                               onWebCancelRecord={this.onWebCancelRecord}/>

                {reply &&
                <div className="classroom-reply">
                    <span className="title">回复</span>
                    {reply}
                    <span className="close" onClick={this.onCloseReply}>
	                		<i className="iconfont icon-cuowu"/>
	                	</span>
                </div>
                }
                <div id="controlBar" className={`classroom-control-bar weui-flex ` + (showInput ? "writing" : "") }>
                    {this.state.inputMode === 'text' &&
                    <component className="flex_1 weui-btn_default menu-button fx-menu-button"
                               onClick={this.onRecordAudio}>
                        <i className="iconfont icon-xinbanketangye-maikefeng menu-font"/>
                    </component>
                    }
                    {this.state.inputMode === 'text' &&
                    <component className="flex_4 text-input">
                        <textarea id="controlSendText" className="send-text" placeholder="发送文字" ref="textInput"
                                  onFocus={this.onTextInputFocus}
                                  onBlur={this.onTextInputBlur}
                                  onChange={this.onTextInputKeyUp}
                                  readOnly={isNewWeiXinMachine()}
                                  onClick={this.onTextInputFocus}
                        />
                    </component>
                    }
                    {this.state.inputMode === 'press_to_record' &&
                    <component className="flex_1 weui-btn_default menu-button"
                               onClick={e => this.setState({inputMode: 'text'})}>
                        <i className="iconfont icon-xinbanketangye-jianpan menu-font"/>
                    </component>
                    }
                    {this.state.inputMode === 'press_to_record' &&
                    <component className={'flex_4 voice-input ' + (this.canShowRecordingTips() ? 'pressing' : '')}
                               ref="voiceInput"
                               onTouchStart={this.onVoiceInputTouchStart}
                               onTouchMove={this.onVoiceInputTouchMove}
                               onTouchEnd={this.onVoiceInputTouchEnd}
                               onClick={this.onVoiceInputClick}
                    >
                        {this.getRecordButtonLabel()}
                    </component>
                    }
                    <input type="submit" className="flex_1 weui-btn weui-btn_primary text-send"
                           value="发送"/>
                    <component className="flex_1 weui-btn_default menu-button"
                               onClick={e => this.setState({showPlusCommands: true})}>
                        <i className="iconfont icon-xinbanketangye-gengduo menu-font"/>
                    </component>

                    <component className="flex_1 weui-btn_default menu-button"
                               onClick={this.onShowDiscussPanel}>
                        <i className="iconfont icon-xinbanketangye-pinglun menu-font"></i>
                    </component>

                    <component className="flex_1 weui-btn_default menu-button"
                               onClick={this.onOpenUserMenu}>
                        <i className="iconfont icon-xinbanketangye-caidan menu-font"/>
                    </component>
                    <WKCommentDialog type="ios" title='发送文字' buttons={[
                        { label: '取消', type: 'default', onClick: e => this.setState({ isShowCommentDialog: false }) },
                        { label: '提交', onClick: e => this.onTextSubmit() }
                    ]} show={this.state.isShowCommentDialog}>
                        <textarea
                            rows="4"
                            onChange={this.onTextInputKeyUp.bind(this)}
                            ref={r => this.$textarea = r}
                        >
                        </textarea>
                    </WKCommentDialog>
                </div>
            </form>
        )
    }
}


ClassroomControlBar.contextTypes = {
    page: React.PropTypes.object,
    classroomPage: React.PropTypes.object
};


export default connect((state) => ({
    audioRecorder: state.audioRecorder,
    wechat: state.wechat,
    account: state.account,
    lecture: state.classroom.lecture,
    options: state.classroom.options,
    reply: state.classroom.reply,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomControlBar);




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomControlBar.js